module.exports = __webpack_public_path__ + "img/icon_pc_moon.a67e429.webp";